import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/apiClient";
import AuthShell from "@/components/layout/AuthShell";
import { CheckCircle2, XCircle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState("loading");
  const { user, refreshMe } = useAuth();
  const verification = useRef(null);
  const account = useRef({ user, refreshMe }); account.current = { user, refreshMe };

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    let cancelled = false;
    if (verification.current?.token !== token) verification.current = { token, promise: api.post("/auth/verify-email", { token }) };
    verification.current.promise
      .then(async () => { if (cancelled) return; if (account.current.user) await account.current.refreshMe().catch(() => {}); if (!cancelled) setStatus("ok"); })
      .catch(() => { if (!cancelled) setStatus("error"); });
    return () => { cancelled = true; };
  }, [token]);

  return (
    <AuthShell title="Email verification"
      footer={<Link to="/dashboard" className="text-zinc-200 underline underline-offset-4">Go to dashboard</Link>}>
      <div data-testid="verify-status" className="rounded-md border border-zinc-800 bg-zinc-900/40 p-5">
        {status === "loading" && <p className="text-sm text-zinc-400">Verifying…</p>}
        {status === "ok" && (
          <div className="flex items-center gap-3 text-emerald-400">
            <CheckCircle2 className="h-5 w-5" /> <span className="text-sm">Your email is verified.</span>
          </div>
        )}
        {status === "error" && (
          <div className="flex items-center gap-3 text-red-400">
            <XCircle className="h-5 w-5" /> <span className="text-sm">Invalid or expired verification link.</span>
          </div>
        )}
      </div>
    </AuthShell>
  );
}
